import { render, staticRenderFns } from "./SaveSignatureOrInitials.vue?vue&type=template&id=7ed35030&scoped=true&"
import script from "./SaveSignatureOrInitials.vue?vue&type=script&lang=js&"
export * from "./SaveSignatureOrInitials.vue?vue&type=script&lang=js&"
import style0 from "./SaveSignatureOrInitials.vue?vue&type=style&index=0&id=7ed35030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed35030",
  null
  
)

export default component.exports